import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-balloon__header"
}
const _hoisted_2 = {
  key: 1,
  class: "gfu-balloon__content"
}
const _hoisted_3 = {
  key: 2,
  class: "gfu-balloon__actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-balloon', $options.classNames])
  }, [
    ($options.hasHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header")
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default"),
    ($options.hasContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "content")
        ]))
      : _createCommentVNode("v-if", true),
    ($options.hasActions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}